// extracted by mini-css-extract-plugin
export var blue = "_28-g";
export var brand = "_28-c";
export var darkGrey = "_28-f";
export var disabled = "_28-6";
export var disabledSubtle = "_28-7";
export var error = "_28-8";
export var green = "_28-h";
export var grey = "_28-e";
export var icon = "_28-0";
export var inherit = "_28-b";
export var lightGrey = "_28-d";
export var orange = "_28-j";
export var pink = "_28-l";
export var primary = "_28-1";
export var purple = "_28-m";
export var quaternary = "_28-4";
export var quinary = "_28-5";
export var red = "_28-k";
export var secondary = "_28-2";
export var success = "_28-a";
export var tertiary = "_28-3";
export var warning = "_28-9";
export var white = "_28-n";
export var yellow = "_28-i";